import AppleIcon from '@assets/icons/apple.svg?react';
import GoogleCalendarIcon from '@assets/icons/google-calendar.svg?react';
import OutlookIcon from '@assets/icons/outlook.svg?react';
import YahooIcon from '@assets/icons/yahoo.svg?react';
import { usePublicEventContext } from '@event/contexts/PublicEventContext';
import EventIcon from '@mui/icons-material/Event';
import { Button, Menu, MenuItem, Typography } from '@mui/material';
import { CalendarEvent, google, ics, outlook, yahoo } from 'calendar-link';
import { SVGProps, useCallback, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const MenuItemClassname = 'gap-2';
const MenuItemIconProps: SVGProps<SVGSVGElement> = {
    width: 20,
    height: 20,
};

const AddEventToCalendar = () => {
    const {
        event: { data: event },
    } = usePublicEventContext();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [buttonWidth, setButtonWidth] = useState<number | null>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setButtonWidth(event.currentTarget.clientWidth);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const getEventForCalendar: (plainText?: boolean) => CalendarEvent = useCallback(
        (plainText) => {
            const baseCalendarEvent: CalendarEvent = {
                title: event?.name ?? '',
                description: event?.description,
                start: event?.date_start,
                end: event?.date_end,
            };
            if (plainText) {
                baseCalendarEvent.description = baseCalendarEvent.description?.replace(/<[^>]*>/g, '');
            }
            return baseCalendarEvent;
        },
        [event?.date_end, event?.date_start, event?.description, event?.name]
    );

    const urls = useMemo(
        () => ({
            googleUrl: google(getEventForCalendar()),
            yahooUrl: yahoo(getEventForCalendar(true)),
            outlookUrl: outlook(getEventForCalendar()),
            appleUrl: ics(getEventForCalendar(true)),
        }),
        [getEventForCalendar]
    );

    return (
        <>
            <Button
                className="[grid-area:z] mt-4 rounded"
                disableElevation={false}
                color="neutral-650"
                startIcon={<EventIcon />}
                onClick={handleClick}
            >
                <Typography fontFamily="Roboto" fontSize={15} fontWeight={500} letterSpacing={0.46}>
                    <FormattedMessage id="common.addToCalendar" defaultMessage="ADD TO CALENDAR" />
                </Typography>
            </Button>
            <Menu
                open={open}
                onClose={handleClose}
                anchorEl={anchorEl}
                sx={{
                    '& .MuiPaper-root': {
                        width: buttonWidth,
                    },
                }}
            >
                <MenuItem className={MenuItemClassname} component="a" target="_blank" href={urls.googleUrl}>
                    <GoogleCalendarIcon {...MenuItemIconProps} />
                    Google
                </MenuItem>
                <MenuItem className={MenuItemClassname} component="a" target="_blank" href={urls.yahooUrl}>
                    <YahooIcon {...MenuItemIconProps} />
                    Yahoo
                </MenuItem>
                <MenuItem className={MenuItemClassname} component="a" target="_blank" href={urls.outlookUrl}>
                    <OutlookIcon {...MenuItemIconProps} />
                    Outlook
                </MenuItem>
                <MenuItem className={MenuItemClassname} component="a" href={urls.appleUrl}>
                    <AppleIcon {...MenuItemIconProps} />
                    Apple
                </MenuItem>
            </Menu>
        </>
    );
};

export { AddEventToCalendar };
